module.exports = __webpack_public_path__ + "img/payment-512.a7415a49.png";